export default __webpack_public_path__ + "static/media/Mariana 9781408340547.a7a9b79d.jpg";